import { set } from 'vue'
import { getSellsByItem } from '~/services/rarible'
import { getItem, searchItems, defaultFilters } from '~/services/algolia'
import { getHistory } from '~/services/augmintables'

export const state = () => ({
  walletAddress: null,
  connected: false,
  collection: null,
  nextPage: null,
  filters: defaultFilters(),
  item: null,
  itemOrders: null,
  itemHistory: null,
  muted: false,
})

export const getters = {
  connected: (state) => state.connected,
  collection: (state) => state.collection,
  collectionTotal: (state) => state.collection?.length || 0,
  filters: (state) => state.filters,
  nextPage: (state) => state.nextPage,
  item: (state) => state.item,
  itemOrders: (state) => state.itemOrders,
  itemHistory: (state) => state.itemHistory,
  muted: (state) => state.muted,
}

export const mutations = {
  setSearch(state, search) {
    state.filters.search = search
  },
  setFormat(state, { format, value }) {
    set(state.filters.formats, format, value)
  },
  setStatus(state, { status, value }) {
    set(state.filters.status, status, value)
  },
  setTags(state, tags) {
    state.filters.tags = tags
  },
  setSortType(state, sortType) {
    state.filters.sortType = sortType
  },
  setConnected(state, { isConnected, walletAddress }) {
    state.connected = !!isConnected
    state.walletAddress = walletAddress || null
  },
  setCollection(state, { items, nextPage }) {
    state.collection = items || []
    state.nextPage = nextPage || null
  },
  extendCollection(state, { items, nextPage }) {
    state.collection.push(...items)
    state.nextPage = nextPage || null
  },
  setItem(state, item) {
    state.item = item || null
  },
  setItemOrders(state, orders) {
    state.itemOrders = orders || null
  },
  setItemHistory(state, history) {
    state.itemHistory = history || null
  },
  resetFilters(state) {
    state.filters = defaultFilters()
  },
  setMuted(state, muted) {
    state.muted = muted
  },
}

export const actions = {
  async connect({ commit, dispatch }, { walletAddress }) {
    if (!walletAddress) {
      await dispatch('disconnect')
    } else {
      commit('setConnected', { isConnected: true, walletAddress })
      dispatch('reloadCollection')
    }
  },
  disconnect({ commit }) {
    commit('setConnected', { isConnected: false })
  },
  async loadInitialCollection({ commit }) {
    const result = await searchItems({
      page: 0,
      filters: defaultFilters(),
    })

    console.log('results', result)

    commit('setCollection', result)
  },
  async searchItems({ commit, state }) {
    const result = await searchItems({ filters: state.filters })
    commit('setCollection', result)
  },
  async loadNextPage({ commit, state }) {
    const result = await searchItems({
      filters: state.filters,
      page: state.nextPage,
    })

    commit('extendCollection', result)
  },
  async reloadCollection({ getters, commit, dispatch }) {
    if (!getters.collection) {
      console.log('reload initial')
      return dispatch('loadInitialCollection')
    }

    const { items } = await searchItems({
      filters: getters.filters,
      page: 0,
      // This was causing a BUG that when we minted new NFT the oldest one was trimmed from the list
      // Commenitng this out for now on 9 April 2024
      // Remove after some time if no issues caused by this
      // algoliaOptions: {
      //   hitsPerPage: getters.collectionTotal,
      // },
    })

    commit('setCollection', {
      items,
      nextPage: getters.nextPage,
    })
  },
  setItemById({ commit, state }, itemId) {
    commit('setItemOrders', null)
    commit('setItemHistory', null)

    const item = state.collection?.find((item) => item.objectID === itemId)
    if (item) {
      commit('setItem', item)
    } else {
      commit('setItem', null)
    }

    getItem(itemId).then((item) => commit('setItem', item))
    getSellsByItem(itemId).then((orders) => commit('setItemOrders', orders))
    getHistory(itemId).then((history) => commit('setItemHistory', history))
  },
  async refreshItem({ commit, state }) {
    const itemId = state.item.objectID
    if (!itemId) return

    const orders = await getSellsByItem(itemId) // Wait for pending orders to be ready
    commit('setItemOrders', orders)
    getItem(itemId).then((item) => commit('setItem', item))
    getHistory(itemId).then((history) => commit('setItemHistory', history))
  },
}
